export const FurnituresVatRate = 0.2;
export const CommissionVatRate = 0.2;
export const RentalGuaranteeVatRate = 0.2;

export const ClassicMainResidenceFiscalDeviceId = 1;
